var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwedan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag (3) 1",
    clipPath: "url(#clip0_1626_379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 8.00088C16 8.55032 15.9457 9.08768 15.837 9.60692H7.25132V15.9647C6.08906 15.859 5.00226 15.5028 4.03925 14.9503V9.60692H0.163019C0.0543396 9.08768 0 8.55032 0 8.00088C0 7.45145 0.0543396 6.91107 0.163019 6.39183H4.03925V1.05145C5.00226 0.498996 6.08906 0.14277 7.25132 0.0371094V6.39183H15.837C15.9457 6.91107 16 7.44843 16 8.00088Z",
    fill: "#FFDD00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.03925 1.05078V6.39116H0.163025C0.627931 4.10286 2.07397 2.17078 4.03925 1.05078Z",
    fill: "#14439E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.03925 9.60547V14.9489C2.07095 13.8289 0.627931 11.8938 0.163025 9.60547H4.03925Z",
    fill: "#14439E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.837 9.60547C15.0944 13.2523 11.8702 15.9994 8.00002 15.9994C7.74644 15.9994 7.49889 15.9874 7.25134 15.9632V9.60547H15.837Z",
    fill: "#14439E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.837 6.39094H7.25134V0.0362264C7.49889 0.0120755 7.74644 0 8.00002 0C11.8672 0 15.0944 2.74415 15.837 6.39094Z",
    fill: "#14439E"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwedan);
export default __webpack_public_path__ + "static/media/swedan.2843eeef63e18c5865d734c783e18223.svg";
export { ForwardRef as ReactComponent };